
import moment from 'moment'

export default {
  name: 'EoPodcastPlayerBody',
  props: {
    /**
     * Style: vertical or horizontal arrangement of player
     */
    layout: {
      type: String,
      default: 'horizontal',
    },
    /**
     * Style: color of the interactive elements
     */
    accentColor: {
      type: String,
      default: 'primary',
    },
  },
  data () {
    return {
      currentTime: 0,
      isPausedBySeeking: false,
    }
  },
  computed: {
    isPlaying () {
      return this.$store.getters['podcastPlayer/isPlaying']
    },
    isExtended () {
      return this.$store.getters['podcastPlayer/isExtended']
    },
    isClosed () {
      return this.$store.getters['podcastPlayer/isClosed']
    },
    seekerPosition () {
      return this.$store.getters['podcastPlayer/seeker']
    },
    jumpTo () {
      return this.$store.getters['podcastPlayer/jumpTo']
    },
    selectedEpisode () {
      return this.$store.getters['podcastPlayer/selectedEpisode']
    },
    hasSelectedEpisode () {
      return this.selectedEpisode ? true : false
    },
    episodeTitle () {
      return (this.selectedEpisode?.npo?.title + ' • ' + this.selectedEpisode?.npo?.content) || null
    },
    episodeAudioUrl () {
      return this.selectedEpisode?.npo?.enclosure?.url || null
    },
    episodeImage () {
      return this.selectedEpisode?.podcast?.imageUrl || null
    },
    episodeDate () {
      return this.selectedEpisode?.npo?.date || null
    },
    episodeDescription () {
      return this.selectedEpisode?.npo?.description || null
    },
    episodeDuration () {
      return this.selectedEpisode?.npo?.duration || 0
    },
    episodeDurationInt () {
      if (!this.episodeDuration) return 0
      let result
      const sDuration = this.episodeDuration.split(':')
      result = (parseInt(sDuration[0]) * (60*60)) + (parseInt(sDuration[1]) * 60) + parseInt(sDuration[2])
      return !isNaN(result) ? result : 0
    },
    episodeShareUrl () {
      return this.selectedEpisode?.npo?.shareWhatsAppUrl || null
    },
    episodesUrl () {
      return this.selectedEpisode?.podcast?.episodesUrl || null
    },
  },
  watch: {
    /**
     * Update seeker element with time from audioplayer
     */
    seekerPosition: {
      handler (seekerPosition) {
        if (!isNaN(seekerPosition)) {
          this.currentTime = seekerPosition
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * Audio methods
     */
    setGoNativePlayer (state) {
      if (navigator.userAgent.includes('GoNativeIOS')) {
        this.goNativePlaying = state
        window.location.href = `gonative://backgroundAudio/${state}`
      }
    },
    playAudio () {
      this.$store.dispatch('podcastPlayer/setPlaying', true)
    },
    pauseAudio () {
      this.$store.dispatch('podcastPlayer/setPlaying', false)
    },
    skipAudioBackwards () {
      this.$store.dispatch('podcastPlayer/setJumpTo', this.seekerPosition - 15)
    },
    skipAudioForwards () {
      this.$store.dispatch('podcastPlayer/setJumpTo', this.seekerPosition + 15)
    },
    onSeekerTouchStart () {
      this.pauseAudio()
      this.isPausedBySeeking = true
    },
    jumpAudioTo (value) {
      this.$store.dispatch('podcastPlayer/setJumpTo', Math.floor(value))
      if (this.isPausedBySeeking) {
        this.playAudio()
        this.isPausedBySeeking = false
      }
    },
    /**
     * UI methods
     */
    formatSeekerDuration (v) {
      const seconds = Math.floor(this.episodeDurationInt - v);
      return `-${moment.utc(seconds * 1000).format('HH:mm:ss')?.replace(/^0(?:0:0?)?/, '')}`;
    },
    stopAndClosePlayer () {
      this.$store.dispatch('podcastPlayer/setPlaying', false)
      this.$store.dispatch('podcastPlayer/setExtended', false)

      setTimeout(() => {
        this.$store.dispatch('podcastPlayer/setClosed', true)
        setTimeout(() => {
          this.$store.dispatch('podcastPlayer/clearQueue')
        }, 500)
      }, 350)
    },
    extendPlayer () {
      this.$store.dispatch('podcastPlayer/setExtended', true)
    },
    collapsePlayer () {
      this.$store.dispatch('podcastPlayer/setExtended', false)
    },
    navigateToAllEpisodes () {
      if (this.hasSelectedEpisode && this.episodesUrl) {
        const url = new URL(this.episodesUrl)
        const isSameDomain = window.location.host === url.host
        const isCurrentUrl = window.location.href === url.href

        if (isCurrentUrl) {
          this.collapsePlayer()
        } else if (isSameDomain) {
          const href = new URL(this.episodesUrl)
          this.$router.push({ path: href.pathname })
        } else {
          window.location.href = this.episodesUrl
        }
      }
    },
  },
}
